module.exports = __webpack_public_path__ + "img/MyProfile.66ce545b.png";